export default [
  {
    title: '操作时间',
    key: 'create_time',
    width: 56,
    fixed: true
  },
  {
    title: '操作人',
    key: 'operator',
    width: 98,
    type: 'basic'
  },
  {
    title: '操作动作',
    key: 'content_title',
    width: 32,
    type: 'basic'
  },
  {
    title: '操作结果',
    key: 'content_log',
    width: 242,
    type: 'basic'
  },
  {
    title: '操作平台',
    key: 'platform',
    width: 32,
    type: 'basic'
  },
  {
    title: '操作IP',
    key: 'opt_ip',
    width: 52,
    type: 'basic'
  }
]
